import React from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash'
import { getMainAreas } from '../actions/main-area';

import Sort from './Sort'
import Pagination from './Pagination'

class MainAreaList extends React.Component {
  render() {
    const { handleSubmit, getMainAreas, list, query, order, projects, reset, submitting } = this.props
    if(!list) {
      return(<div/>)
    }
    const { limit, page, count, rows } = list
    const mainAreaRows = rows.map(row => (
      <tr key={row.id}>
        <td><span className="tx-14">{row.project}</span></td>
        <td><span className="tx-14">{row.name}</span></td>
        <td className="text-center"><Link title="แก้ไขพื้นที่หลัก" className="btn-icon-custom text-center mg-sm-b-10 mg-lg-b-0" to={`/mainArea/${row.id}/edit`}>
          <i className="icon ion-gear-b tx-primary tx-20"></i>
        </Link></td>
      </tr>
    ))
    const pagination = count !== 0 ?
      <Pagination limit={limit} page={page} count={count} query={query}
                  onPageClick={getMainAreas}/> : undefined
    const projectOptions = projects ? _.map(projects, (project) => (
      <option key={project.id} value={project.id}>{project.name}</option>
    )) : undefined              
    return(
      <div>
        <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
          <div className="float-right float-btn">
            <Link to={'/mainArea/add'} className="btn btn-primary">สร้างพื้นที่หลัก</Link>
          </div>
          <h4 className="tx-gray-800 mg-b-5">พื้นที่หลัก</h4>
        </div>
        <div className="br-pagebody">
          <div className="br-section-wrapper">
            <div className="br-pagebody">
              
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-layout form-layout-2">
                      <form className="row no-gutters"
                          onSubmit={handleSubmit((values) => {
                            getMainAreas(values)
                          })}>
                        <div className="col-lg-12 mg-t--1 mg-md-t-0">
                          <div className="form-group">
                            <label htmlFor="projectId" className="form-control-label">โครงการ :</label>
                            <Field name="projectId" component="select" className="form-control select2">
                              <option/>
                              {projectOptions}
                            </Field>
                          </div>
                        </div>
                        <div className="col-lg-12">
                      <div className="form-layout-footer bd pd-20 bd-t-0">
                        <button type="submit" className="btn btn-primary mg-r-10" disabled={submitting}>ค้นหา</button>
                        <button type="button" className="btn btn-outline-primary" disabled={submitting} onClick={() => {
                          reset()
                          getMainAreas()
                        }}>ยกเลิก
                        </button>
                      </div>
                    </div>
                      </form>    
                    </div>
                    <br/>
                    <div className="">
                      <div className="table-responsive mg-b-20">
                        <table className="table table-bordered table-colored table-dark">
                          <thead className="thread-light thead-colored thead-primary">
                          
                          <tr>
                            <th className="text-center" scope="col" onClick={() => getMainAreas(query, 'projectId')}>
                              <span className="tx-13">โครงการ</span> <Sort name="projecId" order={order}/>
                            </th>
                            <th className="text-center" scope="col" onClick={() => getMainAreas(query, 'name')}>
                              <span className="tx-13">พื้นที่หลัก</span> <Sort name="name" order={order}/>
                            </th>
                            <th className="text-center" scope="col"><span className="tx-13">Action</span></th>
                          </tr>
                          </thead>
                          <tbody>
                          {mainAreaRows}
                          </tbody>
                        </table>
                      </div>
                    </div>   
                    <div className="row">
                      <div className="col-md-12 mg-b-20">
                        <div className="row align-items-center justify-content-center">
                          {pagination}
                        </div>
                      </div>
                    </div>   
                  </div>
                </div>
                 
            </div>
          </div>  
        </div>  
      </div>  
    )
  }
}

export default reduxForm({
  form: 'main-area-list'
})(MainAreaList)


// WEBPACK FOOTER //
// ./src/components/MainAreaList.js